import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import "./blogDetails.css";

const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await fetch(`https://portfolio-backend-production-832f.up.railway.app/api/blogs/${id}`);
        if (!res.ok) throw new Error("Blog not found");
        const data = await res.json();
        setBlog(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [id]);

  if (loading) return <p className="loading-text">Loading blog, please wait...</p>;
  if (!blog) return <p className="error-text">Blog not found.</p>;

  // Detect code blocks using triple backticks (``` ... ```)
  const renderContent = (content) => {
    const codeRegex = /```([\s\S]*?)```/g; // Match code blocks
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = codeRegex.exec(content)) !== null) {
      // Text before code block
      if (match.index > lastIndex) {
        parts.push({ type: "text", content: content.slice(lastIndex, match.index) });
      }
      // Code block
      parts.push({ type: "code", language: "javascript", content: match[1].trim() });
      lastIndex = codeRegex.lastIndex;
    }

    // Remaining text after last code block
    if (lastIndex < content.length) {
      parts.push({ type: "text", content: content.slice(lastIndex) });
    }

    return parts.map((part, i) =>
      part.type === "text" ? (
        part.content.split("\n").map((line, idx) => <p key={`${i}-${idx}`}>{line}</p>)
      ) : (
        <SyntaxHighlighter
          key={i}
          language={part.language}
          style={tomorrow}
          showLineNumbers
        >
          {part.content}
        </SyntaxHighlighter>
      )
    );
  };

  return (
    <section className="blog-details">
      <div className="details-container">
        <div className="blog-card">
          <img src={blog.image} alt={blog.title} className="details-image" />
          <div className="blog-content">
            <h1 className="details-title">{blog.title}</h1>
            <span className="details-date">{blog.date}</span>
            <div className="details-content">{renderContent(blog.content)}</div>

            {/* ✅ Back button moved to bottom only */}
            <div className="bottom-back-btn">
              <button
                className="back-btn"
                onClick={() => navigate("/", { replace: true })}
              >
                ← Back to Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetails;
